module Meevo.Plugins.Register {
    "use strict";

    export class ServicesSection extends Meevo.Plugins.Register.RegisterSectionBase {
        public tileListView: boolean = true;
        services: any;
        serviceCats: any;
        selectedServiceCat: any;
        showServices: boolean = false;
        showTransactionSearch: Meevo.Plugins.Register.RefundTypes;
        filter: string = "";
        minServiceFilterLength: number = 2;
        showRefundType: Meevo.Plugins.Register.RefundTypes = Meevo.Plugins.Register.RefundTypes.History;
        client: Model.ClientListItem = null;
        transactionSaleLines: any;
        transactionRequest: any = {
            pageNumber: 0,
            itemsPerPage: 25,
            sortDirection: "Descending",
            criteria: {
                saleType: Model.SalesTypeEnum.Service,
                clientId: !!this.client ? this.client.id : null,
                includeAuthorizationPaymentRequest: true,
            }
        };
        scannedTransactionId: string = "";

        toggleView = () => {
            this.tileListView = !this.tileListView;
        }

        get $rootScope() { return this.registerContext.$rootScope; }
        get $q() { return this.registerContext.$q; }
        get $filter() { return this.registerContext.$filter; }
        get $translate() { return this.registerContext.$translate; }

        get endPoints() { return this.registerContext.appSettings.API_ENDPOINTS; }
        get dataService() { return this.registerContext.dataService; }
        get modalService() { return this.registerContext.modalService; }
        get registerNotesService() { return this.registerContext.registerNotesService; }
        get tippyService() { return this.registerContext.tippyService; }

        constructor(registerContext: Meevo.Plugins.Register.RegisterContext) {
            super(Register.RegisterSectionTypeEnum.Services, registerContext, "services", Register.RegisterSectionCatTypeEnum.Sale);
        }

        getServiceCats() {
            if (!this.serviceCats) {
                let request = {
                    pageNumber: 0,
                    itemsPerPage: 1000,
                    sortDirection: Model.SortDirection.Ascending,
                    criteria: {
                        onlyWithServices: true
                    }
                }
                this.dataService.getListPaged(this.endPoints.serviceCategory, request).then((response: any) => {
                    this.serviceCats = response;
                });
            }
        }

        getServices() {
            const request = {
                pageNumber: 0,
                itemsPerPage: 1000,
                sortDirection: Model.SortDirection.Ascending,
                criteria: {
                    serviceCategoryId: this.selectedServiceCat ? this.selectedServiceCat.id : undefined,
                    filter: this.filter.trim().length >= this.minServiceFilterLength ? this.filter : "",
                    isAvailablePackagesOnly: this.registerContext.isRefundMode ? false : null,
                    wildcardType: Model.FilterWildcardType.Contains,
                    currentDateTime: this.registerContext.sale.pastTransactionDateTime
                }
            };

            return this.dataService.getListPaged(this.endPoints.service, request)
                .then((response: any) => {
                    this.services = response;
                });
        }

        getServicesDebounce = _.debounce(() => {
            this.$rootScope.$apply(() => {
                if (this.filter.trim().length >= this.minServiceFilterLength || this.selectedServiceCat) {
                    this.showServices = true;
                    this.getServices();
                }
                else {
                    this.showServices = false;
                }
            })
        }, 300);

        filterChange() {
            this.getServicesDebounce();
        }

        selectServiceCat(serviceCat) {
            this.selectedServiceCat = serviceCat;
            this.showServices = true;
            this.getServices();
        }

        showServiceNote(service) {
            const noteService: Meevo.Plugins.Note.INoteService = {
                entityId: service.id,
                serviceId: service.id,
            };

            return this.registerNotesService.showServiceNote(noteService);
        }

        showCheckoutCustomControls(service, serviceSaleLineItem: Register.ServiceSaleLineItem) {
            let defer = this.$q.defer();
            this.dataService.getItem("service", service.id).then((fullService: any) => {
                serviceSaleLineItem.hasCheckoutCustomControls = fullService.hasCheckoutCustomControls;
                defer.resolve();
            });
            return defer.promise;
        }

        add(service) {
            let serviceSaleLineItem = new Meevo.Plugins.Register.ServiceSaleLineItem({
                displayName: service.displayName,
                shortcut: service.shortcut,
                id: service.id,
                doNotAllowTips: service.doNotAllowTips,
            });

            this.selectedServiceCat = _(this.serviceCats).find(cat => cat.id === service.serviceCategoryId);

            this.showCheckoutCustomControls(service, serviceSaleLineItem)
                .then(() => this.showServiceNote(service))
                .then(() => {
                    let saleLine: Model.SaleLine = {
                        item: serviceSaleLineItem,
                        quantity: 1,
                        client: this.registerContext.selectedClient,
                        clientId: this.registerContext.selectedClient
                            ? this.registerContext.selectedClient.id
                            : undefined,
                        clientType: this.registerContext.selectedClientType,
                        appointmentId: this.registerContext.selectedClientAppointmentId,
                        saleType: Model.SalesTypeEnum.Service,
                        isNew: (this.registerContext.selectedClientType == Model.ClientTypeEnum.Client),
                        isRefund: this.registerContext.isRefundMode,
                        showPoleMessage: Model.SaleLineStatusEnum.Added
                    };

                    // always ask user to select Employee who performed selected service
                    this.registerContext.tempSaleLines = [ saleLine ];
                    if (this.registerContext.selectedClient && this.registerContext.isRefundMode) {
                        this.addRefundSaleLine(service.id, Model.SalesTypeEnum.Service, ()=> this.localReset());
                    } else {
                        this.registerContext.selectSection(RegisterSectionTypeEnum.Employee);
                    }
                });
        }

        finalizeSale(total: any) {
            this.registerContext.sale.total = total;
            this.registerContext.selectSection(RegisterSectionTypeEnum.Cash);
        }

        reset() {
            if (!this.registerContext.isRefundMode && !this.registerContext.sellServicePermission) {
                this.registerContext.showEmptySection();
            }
            this.localReset();
            if (!this.registerContext.previouslySelectedSection || this.registerContext.previouslySelectedSection.sectionType != RegisterSectionTypeEnum.Employee) {
                this.showRefundType = Meevo.Plugins.Register.RefundTypes.History;
                if (this.registerContext.selectedClientType == Model.ClientTypeEnum.Client) {
                    this.client = this.registerContext.selectedClient;
					if (this.registerContext.isRefundMode) {
						this.getServiceSaleLineHistory();
					}
                }
            }
        }

        localReset() {
            this.getServiceCats();
            this.filter = "";
            this.showServices = false;
            this.selectedServiceCat = undefined;
            this.services = undefined;
            this.client = null;
            this.transactionRequest.criteria.clientId = null;

			if (this.registerContext.isRefundMode) {
				this.transactionSaleLines = new Components.BaseClasses.PagedResults<Model.SaleLine, any>(this.dataService, "saleLine", this.onPageLoad);
				this.transactionSaleLines.clearSearch();
			}
			else {
				this.transactionSaleLines = null;
			}

            this.refundSubTotal = 0;
            this.refundTax = 0;
            this.scannedTransactionId = "";
        }


        onPageLoad = (pageNumber, items) => {
            for (var i = 0, len = items.length; i < len; i++) {
                let item = items[i];
                
                let matchedSaleLines = _.where(this.registerContext.sale.saleLines, { refundTransactionId: item.transactionId, refundSaleLineId: item.id, isRefund: true, refundLocationId: item.locationId });
                if (matchedSaleLines.length > 0 && !item.isRefund) {
                    item.isRefund = true;
                    for (let matchedSaleLine of matchedSaleLines) {
                        this.refundSubTotal += this.getRefundPrice(matchedSaleLine, matchedSaleLine.quantity);
                        this.refundTax += this.getRefundTax(matchedSaleLine, matchedSaleLine.quantity);
                        item.item.isRefundClientPackage = (<Model.ServiceSaleLineItem>matchedSaleLine.item).isRefundClientPackage;
                        item.isLinkedRefundLine = matchedSaleLine.isLinkedRefundLine;
                    }
                   
                    item.newQuantity = _(matchedSaleLines).chain().pluck("quantity").reduce((total, quantity) => { return total + quantity },0).value();
                    item.lastNewQuantity = item.newQuantity;
                }
                else {
                    item.newQuantity = item.quantity;
                    item.lastNewQuantity = item.quantity;
                }
            }
        }

        getServiceSaleLineHistory() {
            this.transactionRequest.criteria.clientId = !!this.client ? this.client.id : null;
            this.transactionSaleLines.initSearch(this.transactionRequest);
            this.refundSubTotal = 0;
            this.refundTax = 0;
        }

        getMatchedSaleLines(service) {
            var refundProps = { refundTransactionId: service.transactionId, refundSaleLineId: service.id, isRefund: true, refundLocationId: service.locationId };

            let matchedSaleLines = _.where(this.registerContext.sale.saleLines, refundProps);

            return matchedSaleLines;
        }

        private showNoRefundReasons(service: Model.SaleLine) {
            switch (service.noRefundReason) {
                case Model.SaleLineNoRefundReasonEnum.UnlimitedPackage:
                    service.isRefund = false;

                    const serviceName = service.item.shortcut + ': ' + service.item.displayName;
                    const message = this.$translate.instant('MESSAGE_NO_REFUND_UNLIMITED_PACKAGE', { 'serviceName': service.item.displayName });
                    this.modalService.alert(message);
                    return false;
            }

            return true;
        }

        refundItemClicked(service: Model.SaleLine) {
            if (!this.showNoRefundReasons(service)) {
                return;
            }

            let services = [service];
            if (service.isRefund) {
                const refundSaleLines: Model.SaleLine[] = _(this.transactionSaleLines.loadedPages).flatten().filter(line => line.isRefund);

                if (this.registerContext.isMismatch(this.tippyService.getExternalRefundTransactionId(this.registerContext.sale), service.externalTipTransactionId) ||
                    this.hasExternalTipTransactionIdMismatch(refundSaleLines)
                ) {
                    this.registerContext.displayRefundMismatchMessage(true, false);
                    service.isRefund = false;
                    return;
                }
                
                if (this.registerContext.isMismatch(this.registerContext.getAuthorizationPaymentRequestId(this.registerContext.sale), service.authorizationPaymentRequestId) ||
                    this.hasAuthorizationPaymentRequestIdMismatch(refundSaleLines)
                ) {
                    this.registerContext.displayRefundMismatchMessage(false, true);
                    service.isRefund = false;
                    return;
                }

                this.autoSelectServiceSwapFeeSaleLine(service, true, services);
                this.autoSelectLinkedRedeemedPutPackageRefundLine(service, true, services);
                for (let selectedService of services) {
                    this.refundSubTotal += this.getRefundPrice(selectedService, selectedService.newQuantity);
                    this.refundTax += this.getRefundTax(selectedService, selectedService.newQuantity);
                }
            }
            else {
                this.autoSelectServiceSwapFeeSaleLine(service, false, services);
                this.autoSelectLinkedRedeemedPutPackageRefundLine(service, false, services);

                for (let unselectedService of services) {
                    let matchedSaleLines = this.getMatchedSaleLines(unselectedService);
                    if (matchedSaleLines.length > 0) {
                        for (let matchedSaleLine of matchedSaleLines) {
                            this.refundSubTotal -= this.getRefundPrice(matchedSaleLine, matchedSaleLine.newQuantity);
                            this.refundTax -= this.getRefundTax(matchedSaleLine, matchedSaleLine.newQuantity);
                        }
                    } else {
                        this.refundSubTotal -= this.getRefundPrice(unselectedService, unselectedService.newQuantity);
                        this.refundTax -= this.getRefundTax(unselectedService, unselectedService.newQuantity);
                    }
                    (<ServiceSaleLineItem>unselectedService.item).isRefundClientPackage = false;
                }
            }
        }

        autoSelectServiceSwapFeeSaleLine(saleLine: Model.SaleLine, isSet: boolean, services: any[]) {
            if (saleLine.saleType !== Model.SalesTypeEnum.Service || !this.registerContext.saleLineHasLinkedIds(saleLine)) {
                return;
            }
            let linkedRefundLine = this.getLinkedSaleLine(saleLine);
            if (linkedRefundLine
                && linkedRefundLine.saleType === Model.SalesTypeEnum.PackageServiceSwapFee) {
                if (linkedRefundLine.isRefund !== isSet)
                {
                    services.push(linkedRefundLine);
                }
                linkedRefundLine.isRefund = isSet;
                linkedRefundLine.isLinkedRefundLine = isSet;
                saleLine.isLinkedRefundLine = isSet;
            }
        }

        autoSelectLinkedRedeemedPutPackageRefundLine(saleLine: Model.SaleLine, isSet: boolean, services: any[]) {
            if (saleLine.saleType !== Model.SalesTypeEnum.Service || !this.registerContext.saleLineHasLinkedIds(saleLine)) {
                return;
            }
            let linkedRefundLine = this.getLinkedSaleLine(saleLine);
            if (linkedRefundLine &&
                (!!saleLine.redeemedPackageItems &&
                    saleLine.redeemedPackageItems.find(item => item.itemType == Model.PackageItemTypeEnum.ProductUnit) ||
                (!!linkedRefundLine.redeemedPackageItems &&
                    linkedRefundLine.redeemedPackageItems.find(item => item.itemType == Model.PackageItemTypeEnum.ProductUnit)))
            ) {
                linkedRefundLine.isRefund = isSet;
                linkedRefundLine.isLinkedRefundLine = isSet;
                services.push(linkedRefundLine);
            }
        }

        getLinkedSaleLine(saleLine: Model.SaleLine, allSaleLines?: Model.SaleLine []) {
            allSaleLines = allSaleLines || _(this.transactionSaleLines.loadedPages).flatten();
            return allSaleLines.find(saleLineCandidate =>
                saleLineCandidate.locationId === saleLine.locationId &&
                moment(saleLineCandidate.saleDate).isSame(saleLine.saleDate) &&
                saleLineCandidate.saleId === saleLine.saleId &&
                !!saleLineCandidate.linkedSaleLineIds.find(linkedSaleLineId => linkedSaleLineId === saleLine.id))
        }

        updateQuantity(saleLine) {
            if (saleLine && saleLine.isRefund && saleLine.finalItemPrice) {
                this.refundSubTotal -= this.getRefundPrice(saleLine, saleLine.lastNewQuantity);
                this.refundTax -= this.getRefundTax(saleLine, saleLine.lastNewQuantity);

                this.refundSubTotal += this.getRefundPrice(saleLine, saleLine.newQuantity);
                this.refundTax += this.getRefundTax(saleLine, saleLine.newQuantity);

                saleLine.lastNewQuantity = saleLine.newQuantity;
            }
        }

        getRefundTax(saleLine: Model.SaleLine, quantity: number): number {
            if (!saleLine) {
                return 0;
            }

            if (saleLine.priceIncludesTax) {
                return 0;
            }

            if (saleLine.redeemedPackageItems) {
                let tax = 0;
                quantity = this.getRefundRedeemedItemQuantity(saleLine, quantity);
                for (let i = 0; i < quantity; i++) {
                    let item = saleLine.redeemedPackageItems[i];
                    for (let lineTax of item.taxes || []) {
                        tax += lineTax.finalAmount;
                    }
                    for (let charge of item.charges || []) {
                        for (let chargeTax of charge.taxes || []) {
                            tax += chargeTax.finalAmount;
                        }
                    }
                }
                return this.registerContext.normalizeDecimalPlaces(tax);
            }

            return saleLine.quantity <= 1
                ? Math.abs(saleLine.finalTax)
                : this.registerContext.normalizeDecimalPlaces(Math.abs(saleLine.originalFinalTax / saleLine.originalQuantity * quantity));
        }

        getRefundPrice(saleLine: Model.SaleLine, quantity: number): number {
            if (!saleLine) {
                return 0;
            }

            if (saleLine.redeemedPackageItems) {
                let price = 0;              
                quantity = this.getRefundRedeemedItemQuantity(saleLine, quantity);
                for (let i = 0; i < quantity; i++) {
                    price += this.registerContext.getRedeemedPackageItemPriceCharge(saleLine.redeemedPackageItems[i]);
                }
                return this.registerContext.normalizeDecimalPlaces(price);
            }
            return this.registerContext.normalizeDecimalPlaces((Math.abs(saleLine.finalItemPrice || 0) + Math.abs(saleLine.finalItemCharge || 0)) * quantity);
        }

        isRefundClientPackageVisible(refundSaleLine) {
            return refundSaleLine && refundSaleLine.item &&
                refundSaleLine.item.usedClientPackageId &&
                refundSaleLine.saleType === Model.SalesTypeEnum.Service &&
                !refundSaleLine.redeemedPackageItems.find(packageItem => packageItem.itemType === Model.PackageItemTypeEnum.ProductUnit);
        }

        isRefundDisabled(refundSaleLine: Model.SaleLine)
        {
            return refundSaleLine && 
                refundSaleLine.isLinkedRefundLine &&
                refundSaleLine.saleType === Model.SalesTypeEnum.PackageServiceSwapFee;
        }

        // put packages redemptions can only have a sale line quantity of 1 so all redeemed items will be refunded
        private getRefundRedeemedItemQuantity(saleLine, refundQuantity) {
            return !!saleLine.redeemedPackageItems.find(item => item.itemType == Model.PackageItemTypeEnum.ProductUnit)
                ? saleLine.redeemedPackageItems.length : refundQuantity;
        }

        applyRefundItems() {
            const allSaleLines: Model.SaleLine[] = _(this.transactionSaleLines.loadedPages).flatten();

            const finishApplyingRefundItems = () => {
                _.chain(allSaleLines)
                    .filter((service) => !!service)
                    .each((service) => {
                        if (service.isRefund) {
                            // put packages redemptions can only have a sale line quantity of 1 so can treat as normal sale line refund
                            if (service.redeemedPackageItems &&
                                !service.redeemedPackageItems.find(item => item.itemType == Model.PackageItemTypeEnum.ProductUnit)) {
                                this.registerContext.addPackageRedeemedRefundSaleLine(service, service.saleType, service.newQuantity, false, this.client);
                            }
                            else {
                                service.client = this.client;
                                this.registerContext.addRefundSaleLine(service, service.saleType);
                            }
                        }
                        else {
                            //could be multiple if refund sale line got split due to having different prices 
                            // because of package charges with redemption
                            let matchedSaleLines = this.getMatchedSaleLines(service);
                            this.registerContext.sale.saleLines = _(this.registerContext.sale.saleLines).without(...matchedSaleLines);
                        }
                    })
                    .value();

                this.registerContext.recalculateSale();
            }

            const linkedSaleLines = allSaleLines.filter(saleLine => saleLine.saleType === Model.SalesTypeEnum.Service && 
                saleLine.isRefund && this.registerContext.saleLineHasLinkedIds(saleLine) && !this.getLinkedSaleLine(saleLine, allSaleLines));
            if (linkedSaleLines.length > 0) {
                
                var request = {
                    linkedSaleLines: linkedSaleLines.map(serviceRefund => {
                        return {
                            locationId: serviceRefund.locationId,
                            saleDate: serviceRefund.saleDate,
                            saleId: serviceRefund.saleId,
                            saleLineId: serviceRefund.linkedSaleLineIds[0]
                        }
                    })
                }
                
                this.dataService.customMethodData('api/SaleLine/LinkedSaleLine/List', 'POST', request).then(res => {
                    if (res.data) {
                        res.data.forEach(newRefundLine => {
                            newRefundLine.isRefund = true;
                            allSaleLines.push(newRefundLine);
                        });
                    }
                    finishApplyingRefundItems();
                })

                return;
            }

            finishApplyingRefundItems();
        }

        refundTransaction() {
            this.registerContext.getSaleLinesToRefundFromTransactionId(this.scannedTransactionId).then(() => { this.scannedTransactionId = ""; });
        }

        categoryColor(bgColor) {
            var rgba = this.$filter<any>('rgba')( bgColor );

            return { "background": rgba };
        }

        canApplyRefund(): boolean {
            return true;
        }
    }
}